import React from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import classnames from 'classnames';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

interface Props {
  button?: React.ReactNode;
  className?: string;
  description: string | React.ReactNode;
  number: string;
  selected?: boolean;
  onClick?: () => void;
}

function InfoCard({ button, className, description, number, selected, onClick }: Props) {
  const classes = useStyles();
  const cardClassName = classnames(
    {
      [classes.root]: true,
      [classes.clickable]: !!onClick,
      [classes.selected]: !!selected,
    },
    className,
  );
  const descriptionNode =
    typeof description === 'string' ? (
      <p className={classes.description}>{description}</p>
    ) : (
      description
    );

  return (
    <Card className={cardClassName} onClick={onClick || undefined}>
      <CardContent className={classes.content}>
        <div className={classes.number}>{number}</div>
        {descriptionNode}
        {button || null}
      </CardContent>
    </Card>
  );
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    width: 200,
    textAlign: 'center',
  },
  clickable: {
    cursor: 'pointer',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 154,
    boxSizing: 'border-box',
    '& > *': {
      marginBottom: 7,
    },
    '& > *:last-child': {
      marginBottom: 0,
    },
  },
  description: {
    marginTop: 0,
  },
  number: {
    fontSize: theme.spacing(5),
  },
  selected: {
    border: `3px solid ${theme.palette.secondary.main}`,
  },
}));

export default InfoCard;
